import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ErrorMessagesComponent } from '@components/error-messages/error-messages.component';
import { NavbarComponent } from '@components/navbar/navbar.component';

@NgModule({
  declarations: [NavbarComponent, ErrorMessagesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    TranslateModule,
  ],
  exports: [NavbarComponent, ErrorMessagesComponent],
})
export class SharedUiModule {}
